import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import type { ProductFamily } from '@evi/store-kit';
import { hasChoices, productPath } from '@evi/store-kit';
import { formatUsd } from '@/lib/api';
import styles from './FamilyCard.module.css';

/** A product family card: hero image, title, "From $X", option count. Links to
 *  the family's first (recommended) variant detail page. */
export function FamilyCard({ family }: { family: ProductFamily }) {
  const first = family.variants[0];
  if (!first) return null;
  const choices = hasChoices(family);
  return (
    <Link to={productPath(first.product)} className={styles.card}>
      <div className={styles.media}>
        {family.media?.hero ? (
          <img src={family.media.hero} alt={family.title} loading="lazy" />
        ) : (
          <div className={styles.mediaFallback} aria-hidden />
        )}
      </div>
      <div className={styles.body}>
        <h3 className={styles.title}>{family.title}</h3>
        {family.blurb && <p className={styles.blurb}>{family.blurb}</p>}
        <div className={styles.foot}>
          <span className={styles.price}>
            {choices && <span className={styles.from}>From </span>}
            {formatUsd(family.fromPriceCents)}
          </span>
          <span className={styles.cta}>
            {choices ? `${family.variants.length} options` : 'View'}
            <ArrowRight size={16} />
          </span>
        </div>
      </div>
    </Link>
  );
}
